import React from "react";

import { BentoBox } from "@components/DataDisplay/BentoBox";

import { mediaQueriesV2 } from "@ui/themes/default";

import { useTranslate } from "@hooks/useTranslate";

import * as Styled from "./Bento12.styled";
import firstImgMobile from "./assets/mobile/3.1.webp";
import firstImgTablet from "./assets/tablet/3.1.webp";
import firstImgDesktop from "./assets/desktop/3.1.webp";
import firstImgLargeDesktop from "./assets/largeDesktop/3.1.webp";

const base64 =
  "data:image/png;base64,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";

export const Bento12: React.FC = () => {
  const translate = useTranslate("batmaid_pwa_static_homepage");

  return (
    <BentoBox
      testId="bento_v3_first_box"
      variant="large"
      heading={translate("bento_v3_first_box_heading")}
      description={
        <Styled.DescriptionLimiter>
          {translate("bento_v3_first_box_description")}
        </Styled.DescriptionLimiter>
      }
      backgroundColor="lavender400"
    >
      <BentoBox.Image
        width={3200}
        height={1448}
        src={firstImgMobile}
        alt={translate("bento_v3_first_box_img_alt")}
        base64={base64}
        loading="lazy"
        sources={
          <React.Fragment>
            <source
              srcSet={firstImgMobile}
              media={mediaQueriesV2.largeMobile}
            />
            <source
              srcSet={firstImgTablet}
              media={mediaQueriesV2.smallTablet}
            />
            <source srcSet={firstImgTablet} media={mediaQueriesV2.tablet} />
            <source
              srcSet={firstImgDesktop}
              media={mediaQueriesV2.smallDesktop}
            />
            <source srcSet={firstImgDesktop} media={mediaQueriesV2.desktop} />
            <source
              srcSet={firstImgLargeDesktop}
              media={mediaQueriesV2.largeDesktop}
            />
          </React.Fragment>
        }
      />
    </BentoBox>
  );
};
